define('templates/helpers/dateType',["handlebars"], function( Handlebars ) {
  var dateType = function(context) {
    if (context == null) {
      return "";
    }
    if (context.Manual) {
      return new Handlebars.SafeString("<strong>" + context.DateName + "</strong>");
    }
    return context.DateName;
  };
  Handlebars.registerHelper("dateType", dateType);
  return dateType;
});
